import React from 'react';

export default function PrivacyPolicyDE() {
  return (
    <div>
      <h2>
        <strong>BEGRIFFSBESTIMMUNGEN</strong>
      </h2>
      <p>
        <strong>Verkäufer</strong> – UAB „Imunodiagnostika“, ein privates Unternehmen, eingetragen im Register der
        juristischen Personen der Republik Litauen, Code: 303064228, USt.-ID: LT100008020911, eingetragene Adresse:
        Molėtų g. 16, Didžioji Riešė, LT-14260, Bezirk Vilnius, Litauen.
      </p>
      <p>
        <strong>Self.co</strong> – der Online-Shop unter
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>
        .
      </p>
      <p>
        <strong>Käufer</strong> –
      </p>
      <ol>
        <li>
          eine geschäftsfähige natürliche Person, die eine Bestellung bei Self.co aufgibt (d. h. eine volljährige
          Person, deren Handlungsfähigkeit nicht durch ein Gericht eingeschränkt ist);
        </li>
        <li>
          ein Minderjähriger zwischen 14 und 18 Jahren mit Zustimmung der Eltern oder Erziehungsberechtigten (sofern
          nicht emanzipiert);
        </li>
        <li>eine juristische Person;</li>
        <li>ein ordnungsgemäß bevollmächtigter Vertreter einer der oben genannten Personen.</li>
      </ol>
      <p>
        <strong>Partner des Verkäufers</strong> – eine juristische Person, die:
      </p>
      <ol>
        <li>Waren oder Dienstleistungen über Self.co verkauft oder an der Erfüllung der Bestellung beteiligt ist;</li>
        <li>
          gemeinsam mit Self.co Aktionen oder Projekte auf der Website, auf eigenen Seiten oder in Medienkanälen
          durchführt.
        </li>
      </ol>
      <p>
        <strong>Self.co-Konten</strong> – offizielle Self.co-Seiten in sozialen Netzwerken wie Facebook, Twitter,
        LinkedIn usw., auf denen Informationen über Self.co-Dienstleistungen veröffentlicht und von Käufern erstellte
        Inhalte geteilt werden.
      </p>
      <p>
        <strong>Dienstleistungen</strong> – alle über Self.co angebotenen Dienstleistungen.
      </p>
      <p>
        <strong>Cookie</strong> – eine kleine Datei, die beim Besuch von Self.co auf ein Gerät gesendet wird. Dieser
        Begriff umfasst auch ähnliche Tracking-Technologien.
      </p>
      <p>
        <strong>Browser</strong> – eine Software zur Anzeige von Webseiten.
      </p>
      <p>
        <strong>Bestellung</strong> – das Ergebnis der Registrierung eines Käufers auf Self.co, wodurch ein Datensatz
        mit persönlichen Daten und Bestellhistorie erstellt wird.
      </p>
      <p>
        <strong>Personenbezogene Daten</strong> – alle Informationen (einschließlich der Angaben im
        Patientenfragebogen), die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen, deren
        Identität direkt oder indirekt bestimmt werden kann, z. B. anhand einer persönlichen Kennung oder spezifischer
        Merkmale.
      </p>
      <p>
        <strong>Patientenfragebogen</strong> – ein Formular, das bei der Bestellung ausgefüllt wird und Informationen
        über mögliche allergische Reaktionen und Umweltfaktoren enthält, um genauere Testergebnisse zu gewährleisten.
      </p>
      <p>
        <strong>Verantwortlicher für personenbezogene Daten</strong> – UAB „Imunodiagnostika“.
      </p>
      <p>
        <strong>Datenschutzerklärung</strong> – dieses Dokument, das die Grundregeln für die Erhebung, Speicherung,
        Verarbeitung und Nutzung personenbezogener Daten bei der Nutzung von Self.co festlegt.
      </p>
      <p>
        <strong>Administrator</strong> – die für das Marketing von Self.co verantwortliche Person.
      </p>
      <p>
        <strong>IP-Adresse</strong> – eine eindeutige Nummer, die jedem mit dem Internet verbundenen Gerät zugewiesen
        wird und häufig zur Identifizierung des Landes verwendet wird, in dem sich das Gerät befindet.
      </p>
      <p>
        <strong>Bedingungen</strong> – die aktuell geltenden „Allgemeinen Geschäftsbedingungen“.
      </p>
      <p>
        <strong>Direktmarketing</strong> – jede Tätigkeit, bei der Waren oder Dienstleistungen per Post, Telefon oder
        anderen direkten Mitteln angeboten oder Meinungen dazu eingeholt werden.
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <h2>
        <strong>ALLGEMEINE BESTIMMUNGEN</strong>
      </h2>
      <p>
        Diese Datenschutzerklärung legt die grundlegenden Regeln für die Erhebung, Speicherung und Verarbeitung
        personenbezogener Daten fest, wenn der Käufer die von Self.co angebotenen Dienstleistungen nutzt.
      </p>
      <p>
        Zweck dieser Datenschutzerklärung ist es, die personenbezogenen Daten der Käufer vor unrechtmäßiger Nutzung zu
        schützen.
      </p>
      <p>
        Ein Käufer gilt als mit dieser Datenschutzerklärung einverstanden, sobald er seine Zustimmung zur Verarbeitung
        seiner personenbezogenen Daten gibt.
      </p>
      <p>
        Diese Datenschutzerklärung ist jederzeit unter
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        einsehbar und kann ausgedruckt werden. Alle Änderungen oder Ergänzungen werden auf Self.co veröffentlicht. Der
        Käufer hat bei jeder Registrierung oder Bestellung die Möglichkeit, die aktualisierte Version zu lesen und zu
        bestätigen. Die geänderte Datenschutzerklärung tritt mit ihrer Veröffentlichung auf Self.co in Kraft.
      </p>
      <p>
        Bitte beachten Sie, dass Self.co Links zu Websites anderer Personen, Unternehmen oder Organisationen enthalten
        kann. Der Verkäufer ist nicht verantwortlich für den Inhalt dieser Websites oder deren Datenschutzpraktiken.
        Käufer sollten die Nutzungsbedingungen und Datenschutzrichtlinien dieser Websites prüfen, bevor sie
        personenbezogene Daten übermitteln.
      </p>
      <p>
        Um eine Bestellung aufzugeben, muss der Käufer folgende personenbezogene Daten angeben: Name, Nachname,
        Geschlecht, Geburtsdatum, E-Mail-Adresse, Telefonnummer, Wohnadresse und die gewählte Klinik. Der Käufer ist für
        die Richtigkeit dieser Daten verantwortlich.
      </p>
      <p>
        Der Käufer muss den Patientenfragebogen ausfüllen, damit der Verkäufer die Dienstleistungen ordnungsgemäß
        erbringen kann.
      </p>
      <p>
        Beim Absenden einer Bestellung gibt der Käufer seine eigenen Daten (oder die des Patienten) ein: Name, Nachname,
        Geschlecht, Geburtsdatum, E-Mail-Adresse, Telefonnummer, Wohnadresse, gewählte Klinik und den ausgefüllten
        Fragebogen. Für die Richtigkeit der Daten ist ausschließlich der Käufer verantwortlich.
      </p>

      <h2>
        <strong>VERARBEITUNG UND NUTZUNG PERSONENBEZOGENER DATEN</strong>
      </h2>
      <p>
        Der Käufer stimmt zu, dass seine (und/oder die des Patienten) Daten – Name, Nachname, Geschlecht, Geburtsdatum,
        E-Mail-Adresse, Telefonnummer, Wohnadresse, Angaben aus dem Fragebogen und IP-Adresse – von Self.co zu
        Analysezwecken verarbeitet werden dürfen.
      </p>
      <p>
        Der Käufer kann bei der Bestellung entscheiden, ob seine Daten für&nbsp;
        <strong>Direktmarketingzwecke</strong> verarbeitet werden dürfen.
      </p>
      <p>
        Möchte der Käufer nach dem Kauf nicht, dass seine Daten für Direktmarketing oder Analyse verwendet werden, kann
        er eine E-Mail an&nbsp;<strong>hello@self.co</strong> senden und angeben, dass er keine E-Mails oder
        SMS-Nachrichten erhalten möchte.
      </p>
      <p>
        Der Verkäufer bestätigt, dass personenbezogene Daten nur verarbeitet werden, um Dienstleistungen über Self.co
        bereitzustellen (einschließlich der Teilnahme an Aktionen oder Projekten). Mit Zustimmung des Käufers können die
        Daten auch für Geschäftsanalysen, Direktmarketing und die Bereitstellung detaillierter Ergebnisse verwendet
        werden. Daten für Direktmarketing werden für&nbsp;<strong>3 Jahre</strong> ab dem Zeitpunkt der Übermittlung
        gespeichert.
      </p>
      <p>
        Der Verkäufer verpflichtet sich, personenbezogene Daten nicht an Dritte weiterzugeben, außer in folgenden
        Fällen:
        <br />
        &nbsp;a) mit Zustimmung des Käufers;
        <br />
        &nbsp;b) an Partner, die an der Auftragsabwicklung beteiligt sind;
        <br />
        &nbsp;c) zu Marketingzwecken an Partner, sofern der Käufer zugestimmt hat und vertraglich der Datenschutz
        gewährleistet ist;
        <br />
        &nbsp;d) an Strafverfolgungsbehörden, wenn dies gesetzlich vorgeschrieben ist;
        <br />
        &nbsp;e) wenn es notwendig ist, Straftaten zu verhindern oder zu untersuchen.
      </p>
      <h3>
        <strong>Rechte des Käufers</strong>
      </h3>
      <p>
        Der Käufer hat das Recht:
        <br />
        &nbsp;a) eine Kopie seiner gespeicherten personenbezogenen Daten anzufordern;
        <br />
        &nbsp;b) Informationen über die Quellen, Zwecke und Empfänger seiner Daten der letzten 12 Monate zu erhalten;
        <br />
        &nbsp;c) die Verarbeitung zu stoppen, wenn diese gegen gesetzliche Bestimmungen verstößt;
        <br />
        &nbsp;d) der Verarbeitung zu widersprechen (in diesem Fall können keine Dienstleistungen über Self.co genutzt
        werden);
        <br />
        &nbsp;e) seine Zustimmung zur Datenverarbeitung für Marketingzwecke jederzeit zu widerrufen.
      </p>
      <p>
        Ein Ausweisdokument, das bei der Abholung der Dienstleistung vorgelegt wird, wird ausschließlich zur
        Identitätsprüfung verwendet.
      </p>
      <p>
        Mit Zustimmung zu dieser Datenschutzerklärung stimmt der Käufer zu, dass seine Daten an Partner weitergegeben
        werden dürfen, um die Bestellung zu erfüllen.
      </p>
      <p>
        Daten können an EU-/EWR-Länder oder andere Länder unter denselben Bedingungen wie in Litauen übermittelt werden
        und nur für die in dieser Datenschutzerklärung genannten Zwecke.
      </p>
      <p>
        Gemäß dem Standard LST EN ISO 15189:2003 für medizinische Labore werden personenbezogene Daten&nbsp;
        <strong>5 Jahre</strong> lang gespeichert, es sei denn, gesetzliche Vorschriften verlangen eine längere
        Aufbewahrung.
      </p>
      <p>
        Der Verkäufer ergreift technische und organisatorische Maßnahmen, um personenbezogene Daten vor unbefugtem
        Zugriff, Veränderung, Offenlegung, Zerstörung, Identitätsdiebstahl oder Betrug zu schützen. Der Zugriff auf
        Server ist nur autorisierten Personen über passwortgeschützte Zertifikate erlaubt. Alle Self.co-Seiten mit
        Dateneingabe verwenden HTTPS-Verschlüsselung.
      </p>
      <p>
        Der Käufer darf personenbezogene Daten nicht an Dritte weitergeben und muss den Verkäufer sofort über
        Datenschutzverletzungen informieren.
      </p>
      <p>
        Der Verkäufer kann Daten speichern, wenn sie für illegale Aktivitäten verwendet wurden oder ein Verdacht darauf
        besteht, sowie bei Beschwerden oder Verstößen gegen die Nutzungsbedingungen. Die Daten werden nur auf Anfrage
        der Behörden gelöscht.
      </p>
      <p>Anfragen zur Datenverarbeitung müssen schriftlich eingereicht werden:</p>
      <ol>
        <li>persönlich an Molėtų g. 16, Didžioji Riešė, Bezirk Vilnius, Litauen;</li>
        <li>
          per E-Mail an&nbsp;<strong>hello@self.co</strong>.<br />
          <br />
          &nbsp;
        </li>
      </ol>
      <p>
        Der Verkäufer antwortet innerhalb von&nbsp;<strong>30 Kalendertagen</strong>.
      </p>
      <p>Der Administrator kann IP-Adressen zu Diagnose- und Sicherheitszwecken verwenden.</p>

      <h2>
        <strong>BERICHTIGUNG, AKTUALISIERUNG UND LÖSCHUNG PERSONENBEZOGENER DATEN</strong>
      </h2>
      <p>
        Der Käufer erteilt Self.co das Recht, personenbezogene Daten gemäß dieser Datenschutzerklärung zu erheben, zu
        verwalten, zu verarbeiten und zu speichern.
      </p>
      <p>
        Die Zustimmung zur Verarbeitung gilt nur für die Zukunft. Nach einem Widerruf wird die Verarbeitung gestoppt,
        Daten können jedoch weiterhin aufbewahrt werden, wenn dies gesetzlich erforderlich ist (z. B. Speicherung von
        Fragebogendaten für 5 Jahre gemäß ISO-Standard) oder aus Gründen der Sicherheit, öffentlichen Ordnung,
        Kriminalitätsbekämpfung oder zum Schutz rechtlicher Interessen.
      </p>
      <p>
        Der Käufer hat das Recht, seine Daten nach Identitätsprüfung einzusehen. Um zu erfahren, welche Daten Self.co
        gespeichert hat, woher sie stammen, wofür sie verarbeitet werden und an wen sie übermittelt wurden, muss der
        Käufer Self.co per E-Mail kontaktieren. Self.co antwortet innerhalb von&nbsp;<strong>30 Tagen</strong>. Die
        Daten werden einmal pro Kalenderjahr kostenlos bereitgestellt.
      </p>
      <p>
        Wenn Daten unrechtmäßig erhoben oder zu falschen Zwecken verarbeitet wurden, kann der Käufer eine Aussetzung
        verlangen. Bei Ungenauigkeiten kann er eine Berichtigung innerhalb von&nbsp;<strong>5 Werktagen</strong>{' '}
        verlangen.
      </p>
      <p>Bestehen Zweifel an der Richtigkeit der Daten, kann Self.co die Verarbeitung bis zur Überprüfung aussetzen.</p>
      <p>
        Anfragen können an&nbsp;<strong>hello@self.co</strong> gesendet werden.
      </p>

      <h2>
        <strong>ERHEBUNG UND SPEICHERUNG PERSONENBEZOGENER DATEN</strong>
      </h2>
      <p>
        Um die Funktionen der Website bereitzustellen, kann Self.co Cookies auf dem Gerät des Käufers speichern. Cookies
        werden verwendet, um wiederkehrende Besucher zu erkennen, Einkaufsinformationen zu speichern und
        Nutzungsstatistiken zu sammeln. Käufer können Cookies jederzeit einsehen oder löschen. Durch die Zustimmung zu
        dieser Datenschutzerklärung stimmen Käufer der Speicherung von Cookies zu. Der Widerruf ist durch Änderung der
        Browsereinstellungen möglich, kann aber die Funktionalität der Website einschränken.
      </p>
      <h3>
        <strong>Verwendete Cookies</strong>
      </h3>
      <p>
        👉&nbsp;<strong>[Platzhalter für Cookie-Tabelle – hier einfügen]</strong>
      </p>

      <h2>
        <strong>SCHLUSSBESTIMMUNGEN</strong>
      </h2>
      <p>
        Diese Datenschutzerklärung ist am&nbsp;<strong>28. Juni 2016</strong> in Kraft getreten. Änderungen werden gemäß
        Abschnitt 21 dieser Richtlinie bekannt gegeben.
      </p>

      <p>
        ✅&nbsp;<strong>Gültigkeit:</strong> Diese Datenschutzerklärung gilt ab dem Datum der Veröffentlichung auf
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>
        .
      </p>
      <p>&nbsp;</p>
    </div>
  );
}
